

// export const LocalUrl = "http://localhost:8000/"
export const LocalUrl = "https://lord-moh-dev.fandogh.cloud/"